import { Box, Grid, IconButton, Typography } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";

export default function Footer({ lessThanXL, scrollToTopAndShowTerms }) {
  return (
    <>
      <Grid
        container
        sx={{
          alignItems: "end",
          height: "150px",
          color: "#1F1F1F",
        }}
      >
        <Grid item md={6} xs={6}>
          <Typography
            sx={{
              paddingLeft: !lessThanXL ? "70px" : "20px",

              fontWeight: "400",
              lineHeight: "normal",
              fontSize: "24px",
              fontFamily: "Righteous",
            }}
            component="div"
          >
            DokuSense
          </Typography>
        </Grid>

        <Grid item md={6} xs={6}>
          <Typography
            sx={{
              paddingLeft: !lessThanXL ? "70px" : "20px",

              fontWeight: "700",
              lineHeight: "normal",
              fontSize: "18px",
              marginLeft: !lessThanXL ? "100px" : "",
            }}
            component="div"
          >
            Company
          </Typography>
        </Grid>

        <Grid item md={6} xs={6}>
          <Typography
            sx={{
              paddingLeft: !lessThanXL ? "70px" : "20px",

              fontWeight: "400",
              lineHeight: "normal",
              fontSize: "14px",
            }}
            component="div"
          >
            DokuSense is a purpose-built AI agent for working with complex PDFs,
            delivering fast, accurate insights with built-in data anonymization.
          </Typography>
        </Grid>

        <Grid item md={6} xs={6}>
          <Typography
            sx={{
              paddingTop: "5px",
              paddingLeft: !lessThanXL ? "70px" : "20px",
              marginLeft: !lessThanXL ? "100px" : "",
              fontWeight: "400",
              lineHeight: "normal",
              fontSize: "14px",
            }}
            component="div"
          >
            Cognitiva Sp. z o.o.
          </Typography>
          <Typography
            sx={{
              paddingTop: "5px",
              paddingLeft: !lessThanXL ? "70px" : "20px",
              marginLeft: !lessThanXL ? "100px" : "",
              fontWeight: "400",
              lineHeight: "normal",
              fontSize: "14px",
            }}
            component="div"
          >
            Pulawska 472, Warsaw, Poland
          </Typography>
          <Typography
            sx={{
              paddingTop: "5px",
              paddingLeft: !lessThanXL ? "70px" : "20px",
              marginLeft: !lessThanXL ? "100px" : "",
              fontWeight: "400",
              lineHeight: "normal",
              fontSize: "14px",
            }}
            component="div"
          >
            hello@dokusense.ai
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          alignItems: "end",
          height: "150px",
          color: "#1F1F1F",
        }}
      >
        <Grid item md={3}>
          <Typography
            sx={{
              paddingLeft: !lessThanXL ? "70px" : "20px",
              fontWeight: "400",
              lineHeight: "normal",
              fontSize: "16px",
            }}
            variant="h6"
            component="div"
          >
            <span
              onClick={scrollToTopAndShowTerms}
              style={{ cursor: "pointer" }}
            >
              Privacy policy & Terms of Use
            </span>
          </Typography>
        </Grid>
      </Grid>

      <Box
        mt={2}
        sx={{
          background:
            "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
          width: "auto",
          height: "1px",
        }}
      >
        <Grid
          container
          sx={{
            alignItems: "anchor-center",
            paddingBottom: "10px",
            height: "75px",
              color: "#1F1F1F",
          }}
        >
          <Grid item md={6} xs={6}>
            <Box sx={{ paddingLeft: !lessThanXL ? "70px" : "20px" }}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="Linkedin"
              >
                <LinkedInIcon />
              </IconButton>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="X Twitter"
              >
                <XIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item md={6} xs={6}>
            
            <Typography
              sx={{
                paddingLeft: !lessThanXL ? "70px" : "20px",
                marginLeft: !lessThanXL ? "100px" : "",
                fontWeight: "400",
                lineHeight: "normal",
                fontSize: "12px",
              }}
              component="div"
            >
              © {new Date().getFullYear()} DokuSense. All Rights Reserved
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
